module.exports = __webpack_public_path__ + "img/logo.033d4e26.png";